// extracted by mini-css-extract-plugin
export default {"customSelectButton":"customSelectButton__O3a6i"};